module.exports = __webpack_public_path__ + "media/SetA_L3_B.f3e76d45.mp3";